const typeList = {
    "안정형" : {
        keyword : "데드라인에 맞추려면 한달 전부터 먼저 준비해야겠어.",
        description : [
            "평가의 기준이 타인이 아닌 자신에게 있는 건강한 완벽주의자.",
            "완벽주의를 잘 다룰 줄 알며, 완벽주의자가 가지고 있는 계획성, 성실함, 꼼꼼함을 십분 활용하여 자신의 능력을 최대치로 이끌어내어 완벽주의의 순기능을 활용해 좋은 결과를 낸다.",
            "성공하기 위해서 실패는 피할 수 없다는 것을 알기에, 자책하기보다 자신의 실수나 실패를 어떻게 보완할지에 더 많은 에너지를 쏟는다.",
            "결과가 아닌 과정을 조금 더 중시한다.",
            "자신에게 주어진 일에 열정을 많이 가지는 편이다. 일을 처리하는 방식이 꼼꼼하며, 디테일을 중요시한다.",
            "현실이 자신의 높은 기준에 도달하지 못하더라도 인정할 줄 안다.",
            "자신이 원하는 결과에 도달하기까지가 빠른 고속도로가 아니라 구부러진 비포장도로임을 안다.",
            "성장을 위해 늘 도전하기 때문에 높은 성과를 내는 고성과자가 많다.",
        ],
        strength : [
            "자신의 한계를 알고 있기 때문에 성취하기까지의 계획을 현실적으로 짜는 편이다.",
            "부정적인 평가를 크게 두려워하고 자신의 일에 몰두하기 때문에 타인의 평가로 인해 자신의 기준이 흔들리거나 마음이 무너지지 않고 올곧게 목표를 완수할 수 있다."
        ],
        weakness : [
            "꼼꼼한 일 처리에 몰두해 주위 사람들과 갈등이 일어날 수 있습니다.",
            "타인과 협업할 때에 자신의 기준을 내려놓는 연습을 해본다면, 유연하고 더욱 건강한 완벽주의 유형이 될 것입니다."
        ],
    },
    "게으른" : {
        keyword : "계획했던 시간보다 40분이나 늦게 일어났어. 과제는 내일 해야겠다.",
        description : [
            "완벽하게 해내지 못할까 두려워 대개 선택을 망설이고 미루는 편이다.",
            "잘 준비된 상황이 아니면 하기 싫다.",
            "미래가 심히 걱정된다.",
            "사실 두려움과 불안으로 가득한 유형. 주변 사람들에게 게으르다는 평가를 받기 쉽지만 사실 머릿속으로는 가장 바쁜 완벽주의자 유형이다.",
            "어떤 일을 하게 되면 잘 하고 싶은 마음이 크게 앞선다. (부담감이 앞선다)",
            "일을 하기 전에 모든 경우의 수를 생각한다.",
            "데드라인이 다가오기 전까지 일을 미루게 되며, 좀처럼 일을 시작하기 어렵다.",
            "무언갈 하다보면 긴박한 상황이 되어 포기할지 끝까지 할지 고민하는데 시간을 많이 쏟는다.",
            "내가 잘 할 수 있을까? 하는 생각을 자주 한다."
        ],
        strength : [
            "머릿속으로 수만가지 경우의 수를 생각하고 준비하기 때문에 막상 일을 시작하면 실수나 실패가 적은 편이다. ",
            "완성도가 높게 일을 완수한다."
        ],
        weakness : [
            "시작하기까지 두려움과 불안으로 인해 데드라인을 넘겨 포기하고(지연행동)는 자책을 하게 되는 악순환을 반복하지 않기 위해서는 우선 작은 것 하나부터 시작해보는 것이 중요합니다.",
            "완벽하게 완성하기 위해 내가 예상한 소요 시간이 실제 남은 시간에 비하면 턱없이 부족하다 할 지라도 ‘하지 않는 뭐라도 하는 것이 낫다’는 생각을 가지고 하나씩 시작해 보세요.",
        ],
    },
    "감독형" : {
        keyword : "다들 나만큼만 하면 소원이 없겠네!",
        description : [
            "비현실적인 기준일지라도 성취할 수 있을 것 같다는 자신감이 있다.",
            "계획을 꼼꼼하게 짜는 편이다.",
            "계획을 세우고 지키는 일이 재밌다.",
            "나에게 주어진 일은 어떻게 해서든 끝까지 완수해야한다.",
            "조직에 도움이 될 것 같으면 웬만한 일은 다 거절하지 않는다.",
            "가까운 사람에게 잔소리를 많이 하는 편이다.",
            "나르시즘과 강한 관련성을 가지고 있다.",
        ],
        strength : [
            "개인 공간에서의 정리정돈이 잘 되어있고 어떤 일이든 조직화하여 계획대로 해내기 때문에 약속을 잘 지키며 추진력이 있다."
        ],
        weakness : [
            "타인지향적 완벽주의other-oriented perfectionism 성향이 있기 때문에 자칫하면 자신의 기준을 타인에게 동일하게 부과하기도 한다.",
            "자기도 모르는 사이에 타인에게 압박과 엄격한 잣대, 분노, 비난을 줄 수 있으므로 타인의 마음을 다치게 하거나 사기를 꺽지는 않았는지 주의를 기울이는 것이 좋다."
        ],
    },
    "자책형" : {
        keyword : "이 정도로는 늘 부족해.",
        description : [
            "-네 가지 유형 중 심리적으로 가장 힘든 유형. 심리적으로 압박을 받아 불안이 높고 우울, 공황을 경험하기 쉽다.",
            "타인과 지속적으로 비교하며 자신의 성과를 자책한다.",
            "타인의 기준을 나의 기준보다 우선시한다.",
            "과정이 아무리 좋았더라도 결과가 나쁘면 기분이 안 좋아진다.",
            "자신의 장점보다 단점을 확대 해석한다.",
            "주변에서 일어나는 일이 나의 탓인 것만 같다.",
            "나에게 버거운 일도 쉽게 거절하지 못한다.",
            "남들의 평가에 민감하다.",
            "다른 사람의 눈치를 많이 보는 편이다.",
            "좋은 결과를 얻더라도 만족하지 못한다. 혹은 그때 뿐이다.",
            "일이 잘못되면 원인을 나에게서 찾는다."

        ],
        strength : [
            "자신에게 늘 엄격한 편이기에 다른 사람들을 많이 배려한다.",
            "또한 자신이 맡은 부분은 최선을 다하고 무리하면서까지 꼼꼼하게 확인하기 때문에 대체로 나쁘지 않은 결과를 얻는다.",
        ],
        weakness : [
            "타인을 의식해서 그들의 기대를 충족시켜야 한다는 생각이 강하다.",
            "충족시키지 못하면 자책으로 이어지기 대문에 자신에 대한 평가 기준을 스스로가 명확하게 세우는 것이 필요하다.", 
            "다른 사람의 기대에 부응해야 한다는 심리적 압박의 원인을 찾고 자신을 평가하는 것은 다른 누군가가 아닌 바로 자신이라는 것을 기억하자."
        ],
    }
}
Object.freeze(typeList);

export default typeList;